import { Loader2 } from 'lucide-react';
import { ReactNode, useState } from 'react';

type DeleteModalProps = {
  children: ReactNode;
  closeModal: () => void;
  deleteAccount: () => void;
};

export default function DeleteModal({
  children,
  closeModal,
  deleteAccount,
}: DeleteModalProps) {
  // Delete button should only ever be clicked once before the modal closes so this will be set permanently
  const [clicked, setClicked] = useState<boolean>(false);

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]"
      onClick={closeModal}
    >
      <div
        className="flex flex-col items-center text-center w-11/12 max-w-md max-h-[90vh] p-10 gap-5 bg-white rounded-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div>{children}</div>

        <button
          type="button"
          className="shadow-ms hover:shadow-2xl  px-4 py-2 rounded-lg bg-[#227021] hover:bg-[#154e14] font-bold"
          onClick={closeModal}
        >
          No; keep my account
        </button>

        <button
          type="button"
          className="shadow-ms hover:shadow-2xl px-4 py-2 rounded-lg font-bold border-2 border-confirmed-red hover:bg-gray-300 text-confirmed-red"
          onClick={() => {
            setClicked(true);
            deleteAccount();
          }}
          disabled={clicked}
        >
          {clicked ? (
            <Loader2 className="animate-spin" />
          ) : (
            <span>Yes; permanently delete this account</span>
          )}
        </button>

        <div className="text-xl flex flex-col">
          <span>
            Deleting your account will immediately disable all functionality,
            permanently remove your data, remove you from all event rosters, and
            remove connections to you from anybody who connected to you so they
            will no longer be able to access the connection.
          </span>
          <span className="font-bold">
            This will not be able to be reversed.
          </span>
        </div>
      </div>
    </div>
  );
}
